import FlightInquire from './FlightInquire';
export default FlightInquire;
